import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (refresh) {
  const { data, isRequestSuccessed, exec } = useRequest({
    url: '/api/machine/model',
    name: 'MACHINE_MODEL_GET',
    method: 'GET',
  });
  useEffect(() => {
    if (refresh) {
      exec({ url: '/api/machine/model' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);
  return [data || [], isRequestSuccessed, exec];
});
